import { render, staticRenderFns } from "./MembershipProductEditView.vue?vue&type=template&id=bdb9d874"
import script from "./MembershipProductEditView.vue?vue&type=script&lang=js"
export * from "./MembershipProductEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports